<template>
  <div>
    <v-btn v-if="isAdmin" flat @click="modal = true">
      <v-icon>person_add</v-icon>
    </v-btn>

    <paginated-table :items="clients" :headers="headers" :pull-function="pullFunction">
      <template #items="props">
        <td v-for="(header, i) in headers" v-if="header.value !== 'removal'" :key="i">
          <v-btn
            v-if="header.value ==='name'"
            text
            small
            flat
            :to="{ name: 'user', params: { user: props.item.id } }"
            style=" text-transform: none; padding: 0;"
          >
            {{ props.item[header.value] }}
          </v-btn>

          <p v-else-if="header.value === 'roles'">
            {{ props.item[header.value].join(', ') }}
          </p>

          <p v-else>{{ props.item[header.value] }}</p>
        </td>

        <td>
          <v-btn
            small
            fab
            color="secondary"
            :disabled="!user || user.id === props.item.id || !isAdmin"
            @click="removeUser(props.item.id)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </paginated-table>

    <v-dialog v-model="modal" max-width="500px">
      <v-card>
        <v-card-title class="modal-chat__title">Добавление администратора </v-card-title>

        <v-text-field
          v-model="inputValue"
          style="width: 90%; margin: 0 auto 10px"
          label="email"
          color="accent"
          single-line
          hide-details
        />

        <p
          v-if="inputValue"
          :style="{ color: isSuccess ? 'green' : 'red', margin: '0 0 10px 20px' }"
        >
          {{ userFound }}
        </p>

        <v-card-actions>
          <div v-if="isAdmin && userIdToAdd" style="margin-left: 15px">
            <v-btn color="secondary" @click="addUser('super_admin')">Super admin</v-btn>

            <v-btn color="secondary" @click="addUser('admin')">Admin</v-btn>

            <v-btn color="secondary" @click="addUser('manager')">Manager</v-btn>
          </div>

          <v-spacer />

          <v-btn flat @click="modal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lodash from 'lodash'
import api from '../api/'
import PaginatedTable from '@/components/PaginatedTable.vue'
import UserHelper from '../../helpers/user'
import { getUsers } from '../../api/user'

export default {
  components: { PaginatedTable },
  data: () => ({
    modal: false,
    page: 1,
    isAdmin: false,
    clients: [],
    userFound: '',
    isSuccess: false,
    inputValue: '',
    userIdToAdd: null,
    headers: [
      { text: 'User ID', value: 'id' },
      { text: 'Ник', value: 'name' },
      { text: 'Роль', value: 'roles' },
      { text: 'Email', value: 'email' },
      { text: 'Удаление', value: 'removal' }
    ]
  }),
  computed: mapGetters(['user']),
  watch: {
    modal (newVal) {
      if (!newVal) {
        this.userFound = ''
        this.inputValue = ''
      }
    },
    inputValue (newValue) {
      this.inputValue = newValue
      this.getUser()
    }
  },
  mounted () {
    this.pullFunction(1)
    this.isAdmin = UserHelper.hasAdminAccess()
  },
  methods: {
    getUser: lodash.debounce(function () {
      if (this.inputValue)
        getUsers(
          1,
          0,
          this.inputValue
        ).then(({ data }) => {
          if (data.length > 0) {
            this.userIdToAdd = data[0]
            this.isSuccess = true
            this.userFound = 'Пользователь найден!'
          } else {
            this.userIdToAdd = null
            this.isSuccess = false
            this.userFound = 'Пользователь не найден!'
          }
        })
    }, 500),
    addUser (role) {
      api.users.setRoles(this.userIdToAdd.id, [role]).then(() => {
        this.userIdToAdd = null
        this.isSuccess = true
        this.userFound = 'Права пользователя обновлены!'
        this.pullFunction(1)
      })
    },
    removeUser (userId) {
      api.users.setRoles(userId, ['user'])
        .then(() => {
          this.pullFunction(1)
        })
    },
    formattingUSers (data) {
      this.clients = data
        .map(el => ({
          ...el,
          roles: el.roles.map(role => typeof role === 'object' ? role.name : role)
        }))
    },
    pullFunction (page) {
      this.page = page
      api.users.get({
        limit: 26,
        offset: (page - 1) * 25,
        roles: [2, 3, 5]
      }).then(({ data }) => {
        this.formattingUSers(data)
      })
    }
  }
}
</script>
